import "./StatsSection.css";

const stats = [
  {
    number: "50+",
    title: "Afazili Hasta",
    description:
      "İnme veya travma sonrası konuşma bozukluğu yaşayan kişilerle birebir görüşme",
  },
  {
    number: "3+",
    title: "Bilimsel Çalışmalar",
    description:
      "Alanda uzman çeşitli uzmanların yer aldığı kongrelerde bilimsel sözlü sunumlar gerçekleştirdik.",
  },
  {
    number: "3+",
    title: "Kurum İşbirliği ve Görüşmeleri",
    description:
      "Özel Hastane, Evde Bakım Merkezleri ve Rehabilite Merkezleri ile işbirliği görüşmelerine başlandı.",
  },
  {
    number: "65+",
    title: "Terapist ve Uzman Görüşü",
    description:
      "Konuşma bozukluğu alanında veya afazili kişilerle birebir görüşen doktor, terapist ve çeşitli sağlık çalışanlarından görüşler aldık.",
  },
];

const StatsSection = () => {
  return (
    <section className="stats-section">
      <div className="stats-grid">
        {stats.map((item, index) => (
          <div className="stats-box" key={index}>
            <h2 className="stats-number">{item.number}</h2>
            <h3 className="stats-title">{item.title}</h3>
            <p className="stats-description">{item.description}</p>
          </div>
        ))}
      </div>

      <div className="stats-info">
        <h2 className="stats-heading">SAYILARLA BİZ</h2>
        <p className="stats-paragraph">
          Afazi, dil yeteneğini etkileyen bir bozukluktur. Bu durum genellikle
          beynin konuşma bölgesinin etkilenmesi dolayısıyla ortaya çıkar.
        </p>
      </div>
    </section>
  );
};

export default StatsSection;
